export enum ParameterTypeValueTypes {
	UPDATE_CHANGE_FORM = "@parameterTypeValue/UPDATE_CHANGE_FORM",
	RESET_CHANGE_FORM = "@parameterTypeValue/RESET_CHANGE_FORM",
}

export interface ParameterTypeValueState {
	readonly parameterTypeValue: {
		data: boolean;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface SaveParameterTypeValue {
	type: typeof ParameterTypeValueTypes.UPDATE_CHANGE_FORM;
	payload: {
		data: boolean;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerParameterTypeValue {
	type: typeof ParameterTypeValueTypes.RESET_CHANGE_FORM;
}

export type ParameterTypeValueActionTypes = SaveParameterTypeValue | ResetReducerParameterTypeValue;
